import React from "react";
import { Box, BoxProps } from "@material-ui/core";
import { Colors } from "../../constants/colors";

export default function Separator({ ...rest }: BoxProps): JSX.Element {
  return <Box bgcolor={Colors.Grey4} height="1px" {...rest} />;
}
